import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function ErrorStatusIcon({ fill = '#DC3616', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M8 1.33333C4.318 1.33333 1.33333 4.318 1.33333 8C1.33333 11.682 4.318 14.6667 8 14.6667C11.682 14.6667 14.6667 11.682 14.6667 8C14.6667 4.318 11.682 1.33333 8 1.33333ZM7.5 5C7.5 4.724 7.724 4.5 8 4.5C8.276 4.5 8.5 4.724 8.5 5V8.04736C8.5 8.32336 8.276 8.54736 8 8.54736C7.724 8.54736 7.5 8.32336 7.5 8.04736V5ZM8.01335 11C7.64535 11 7.34326 10.7013 7.34326 10.3333C7.34326 9.96533 7.63867 9.66667 8.00667 9.66667H8.01335C8.38201 9.66667 8.68001 9.96533 8.68001 10.3333C8.68001 10.7013 8.38135 11 8.01335 11Z"
        fill={fill}
      />
    </svg>
  );
}

export default ErrorStatusIcon;
